/** A native external scrollport, shared by layout, navigation and animation consumers. */
export default class ScrollContext {
  constructor(node, container) {
    this.window = node.ownerDocument.defaultView;
    this.element = null;
    if (
      container == null ||
      container === "window" ||
      container === this.window
    )
      return;

    if (typeof container === "string") {
      // Walk composed ancestors: the spread itself can live inside a shadow root.
      let ancestor = node;
      while (ancestor) {
        if (ancestor.matches(container)) {
          this.element = ancestor;
          break;
        }
        ancestor = ancestor.parentElement || ancestor.getRootNode().host;
      }
    } else if (container instanceof this.window.HTMLElement) {
      let ancestor = node;
      while (ancestor && ancestor !== container) {
        ancestor = ancestor.parentElement || ancestor.getRootNode().host;
      }
      if (ancestor === container) this.element = container;
    }
    if (!this.element || this.element === node) {
      throw new Error(
        "Maglr scrollContainer must identify an ancestor HTMLElement of the spread",
      );
    }
    if (
      [node.ownerDocument.body, node.ownerDocument.documentElement].includes(
        this.element,
      )
    ) {
      this.element = null;
    }
  }

  get target() {
    return this.element || this.window;
  }
  get top() {
    return this.element
      ? this.element.getBoundingClientRect().top + this.element.clientTop
      : 0;
  }
  get height() {
    return this.element ? this.element.clientHeight : this.window.innerHeight;
  }
  get scrollTop() {
    return this.element ? this.element.scrollTop : this.window.scrollY;
  }

  offsetOf(element) {
    return element.getBoundingClientRect().top - this.top + this.scrollTop;
  }

  scrollTo(top, behavior = "auto") {
    this.target.scrollTo({ top, behavior });
  }
}
